import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { add_question } from "../../../redux/actions/questionActions";

const history = createHashHistory();
class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: "",
      msgType: "",
      question: "",
      questionError: "",
      dealID: "",
      show: "",
      hover: false,
    };
    this.validate = this.validate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleChange(e) {
    e.preventDefault();
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.question.length === 0) {
      isError = true;
      this.setState({ questionError: "red" });
    }
    return isError;
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSubmit(e) {
    this.handleShow();
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      const postData = {
        question: this.state.question,
        dealID: this.state.dealID
      };
      this.props.add_question(postData);
    }
  }

  componentWillMount() {
    this.setState({ dealID: this.props.dealID });
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.addedQuestionResponse !== nextProps.addedQuestionResponse &&
      !isEmpty(nextProps.addedQuestionResponse)
    ) {
      if (nextProps.addedQuestionResponse.response === "success") {
        this.setState({ questionError: "", question: "" });
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.addedQuestionResponse.message
        );
      }
    }
    if (this.props.message !== nextProps.message) {
      this.setState({ alertMessage: nextProps.message });
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.setState({ msgType: nextProps.alertType });
    }
    if (this.props.error !== nextProps.error && nextProps.error !== "") {
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
    }
  }

  render() {
    return (
      <div>
        {this.state.show &&
          this.state.alertMessage !== "" &&
          this.state.msgType && (
            <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
              </Alert>
            </div>
          )}
        <form onSubmit={this.handleSubmit}>
          <Row>
            <Col md={12} xs={12}>
              <FormGroup controlId="formQuestion">
                <ControlLabel>Question</ControlLabel>
                <FormControl
                  value={this.state.question}
                  componentClass="textarea"
                  onChange={this.handleChange}
                  name="question"
                  placeholder="Ask Your Question"
                  style={{ borderColor: this.state.questionError }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="danger"
                disabled={this.props.sendingQustion}
                type="submit"
                className="pull-left"
                id="saveButton"
                style={{backgroundColor: (this.state.hover && this.state.hoverID == "question") ? this.state.mouseover_color : this.state.button_color}}
                data-id = {"question"}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
              >
                Submit Question
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

Question.propTypes = {
  add_question: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sendingQustion: state.questionReducer.sendingQustion,
  addedQuestionResponse: state.questionReducer.addedQuestionResponse,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.questionReducer.error
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { add_question, clearAlert, renderAlert })
)(Question);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Question.js